import { Component } from '@angular/core';

@Component({
  selector: 'upload-documents-instructions',
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss']
})
export class UploadDocumentsComponent {

}
